import { faStar } from "@jewlr/pro-solid-svg-icons/faStar"
import { faStarHalf } from "@jewlr/pro-solid-svg-icons/faStarHalf"
import { faArrowRotateLeft } from "@jewlr/sharp-light-svg-icons/faArrowRotateLeft"
import { faAwardSimple } from "@jewlr/sharp-light-svg-icons/faAwardSimple"
import { faGem } from "@jewlr/sharp-light-svg-icons/faGem"
import { faTruckFast } from "@jewlr/sharp-light-svg-icons/faTruckFast"

import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Media from "components/ui/media"
import { jewlr_t, IS_JEWLR, IS_GE_CHECKOUT } from "helpers/application"

import EmptyOutCart from "../empty-out-cart"
import Help from "../help-footer"

import AcceptPayments from "./accept-payments"

const Footer = () => {
  const is_ge_checkout = IS_GE_CHECKOUT()
  return (
    <>
      {IS_JEWLR() && (
        <>
          <div className="contained tablet:mt-40 mt-24">
            <div className="gap-30 tablet:gap-32 desktop:gap-56 mb-30 tablet:mb-0 flex justify-center">
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faTruckFast}
                />
                <p className="body-sm mx-auto font-medium">
                  FREE
                  <br />
                  {jewlr_t("terms.Shipping")}
                </p>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faAwardSimple}
                />
                <p className="body-sm mx-auto font-medium">
                  One-Year
                  <br />
                  Warranty
                </p>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faArrowRotateLeft}
                />
                <p className="body-sm mx-auto font-medium">
                  {is_ge_checkout ? "30" : "99"}-Day
                  <br />
                  Returns
                </p>
              </div>
              <div className="pb-10 text-center">
                <FontAwesomeIcon
                  className="text-30 tablet:text-48 pb-8 text-black"
                  icon={faGem}
                />
                <p className="body-sm mx-auto font-medium">
                  Made in
                  <br />
                  North America
                </p>
              </div>
            </div>
            <Media className="mb-40 px-48 text-center" lessThan="tablet">
              <p className="text-18 mb-6 font-bold">Customer Reviews</p>
              <p className="text-12 mb-6 font-medium">
                {jewlr_t("terms.Jewelry")} And Customer Experience Is Our
                Passion, And Our Customers Love Us For It.
              </p>
              <p className="text-18 mb-6 font-bold">50K+</p>
              <div className="flex justify-center gap-2">
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStar}
                />
                <FontAwesomeIcon
                  className="text-rating text-12"
                  icon={faStarHalf}
                />
              </div>
            </Media>
          </div>
          <Media className="contained px-16" lessThan="tablet">
            <Help />
          </Media>
        </>
      )}
      <EmptyOutCart />
      <AcceptPayments />
    </>
  )
}
export default Footer
